<template>
    <div
        v-if="isError"
        class="absolute inset-y-0 end-0 flex items-center pointer-events-none pe-8">
        <ExclamationCircleIcon class="shrink-0 size-4 text-red-500" />
    </div>
</template>
<script setup lang="ts">
import { ExclamationCircleIcon } from '@heroicons/vue/24/outline'
defineProps<{
   isError: boolean
}>()
</script>
